// The sidebar menu is derived from the module registry (data-driven).
// To add/remove screens, edit src/jsx/modules/registry.js — not this file.
import { buildMenuList } from '../../modules/registry';

export const MenuList = buildMenuList();
